/*
 * App Messages
 *
 * This contains all the custom text messages
 */

export const scope = "diverst.containers.App";
export const routes = "diverst.containers.Routes";

export default {
  budgetRoute: {
    id: `${routes}.admin.plan.group_budgets`,
  },
  openDrawer: {
    id: `${scope}.drawer`,
  },
  permissions: {
    budget: {
      id: `${scope}.texts.permissions.budget`,
    },
    global: {
      id: `${scope}.texts.permissions.global`,
    },
    system: {
      id: `${scope}.texts.permissions.system`,
    },
  },
  texts: {
    erg: {
      id: `${scope}.texts.erg`,
    },
    program: {
      id: `${scope}.texts.program`,
    },
    structure: {
      id: `${scope}.texts.structure`,
    },
    outcome: {
      id: `${scope}.texts.outcome`,
    },
    badge: {
      id: `${scope}.texts.badge`,
    },
    segment: {
      id: `${scope}.texts.segment`,
    },
    gamification: {
      id: `${scope}.texts.gamification`,
    },
    gamify: {
      id: `${scope}.texts.gamify`,
    },
    member_preference: {
      id: `${scope}.texts.member_preference`,
    },
    parent: {
      id: `${scope}.texts.parent`,
    },
    sub_erg: {
      id: `${scope}.texts.sub_erg`,
    },
    privacy_statement: {
      id: `${scope}.texts.privacy_statement`,
    },
    region: {
      id: `${scope}.texts.region`,
    },
    employee_id: {
      id: `${scope}.texts.employee_id`,
    },
  },
  plural_text: {
    erg: {
      id: `${scope}.texts.plural.erg`,
    },
    program: {
      id: `${scope}.texts.plural.program`,
    },
    structure: {
      id: `${scope}.texts.plural.structure`,
    },
    outcome: {
      id: `${scope}.texts.plural.outcome`,
    },
    badge: {
      id: `${scope}.texts.plural.badge`,
    },
    segment: {
      id: `${scope}.texts.plural.segment`,
    },
    gamification: {
      id: `${scope}.texts.plural.gamification`,
    },
    gamify: {
      id: `${scope}.texts.plural.gamify`,
    },
    member_preference: {
      id: `${scope}.texts.plural.member_preference`,
    },
    parent: {
      id: `${scope}.texts.plural.parent`,
    },
    sub_erg: {
      id: `${scope}.texts.plural.sub_erg`,
    },
    privacy_statement: {
      id: `${scope}.texts.plural.privacy_statement`,
    },
    region: {
      id: `${scope}.texts.plural.region`,
    },
    employee_id: {
      id: `${scope}.texts.plural.employee_id`,
    },
  },
  custom_text: {
    erg: {
      id: `${scope}.custom_text.erg`,
    },
    program: {
      id: `${scope}.custom_text.program`,
    },
    structure: {
      id: `${scope}.custom_text.structure`,
    },
    outcome: {
      id: `${scope}.custom_text.outcome`,
    },
    badge: {
      id: `${scope}.custom_text.badge`,
    },
    segment: {
      id: `${scope}.custom_text.segment`,
    },
    gamification: {
      id: `${scope}.custom_text.gamification`,
    },
    gamify: {
      id: `${scope}.custom_text.gamify`,
    },
    member_preference: {
      id: `${scope}.custom_text.member_preference`,
    },
    parent: {
      id: `${scope}.custom_text.parent`,
    },
    sub_erg: {
      id: `${scope}.custom_text.sub_erg`,
    },
    privacy_statement: {
      id: `${scope}.custom_text.privacy_statement`,
    },
    region: {
      id: `${scope}.custom_text.region`,
    },
    employee_id: {
      id: `${scope}.custom_text.employee_id`,
    },
  },
  days_of_week: [
    {
      id: `${scope}.dayOfWeek.sunday`,
    },
    {
      id: `${scope}.dayOfWeek.monday`,
    },
    {
      id: `${scope}.dayOfWeek.tuesday`,
    },
    {
      id: `${scope}.dayOfWeek.wednesday`,
    },
    {
      id: `${scope}.dayOfWeek.thursday`,
    },
    {
      id: `${scope}.dayOfWeek.friday`,
    },
    {
      id: `${scope}.dayOfWeek.saturday`,
    },
  ],
  none: {
    id: `${scope}.none`,
  },
  confirmation: {
    yes: {
      id: `${scope}.confirmation.yes`,
    },
    no: {
      id: `${scope}.confirmation.no`,
    },
  },
  currency: {
    placement: {
      id: `${scope}.currency.placement`,
    },
    symbol: {
      id: `${scope}.currency.symbol`,
    },
    defaultSymbol: {
      id: `${scope}.currency.defaultSymbol`,
    },
  },
  person: {
    givenName: {
      id: `${scope}.person.givenName`,
    },
    familyName: {
      id: `${scope}.person.familyName`,
    },
    email: {
      id: `${scope}.person.email`,
    },
  },
  budgets: {
    quarterAbbreviation: {
      id: `${scope}.budgets.quarterAbbreviation`,
    },
    yearAbbreviation: {
      id: `${scope}.budgets.yearAbbreviation`,
    },
    yearAndQuarter: {
      id: `${scope}.budgets.yearAndQuarter`,
    },
  },
  header: {
    dashboard: {
      id: `${scope}.header.dashboard`,
    },
    admin: {
      id: `${scope}.header.admin`,
    },
    userMenu: {
      id: `${scope}.header.userMenu`,
    },
    profile: {
      id: `${scope}.header.profile`,
    },
    logout: {
      id: `${scope}.header.logout`,
    },
  },
  success: {
    logout: {
      id: `${scope}.success.logout`,
    },
  },
  errors: {
    loginIncorrect: {
      id: `${scope}.errors.login.incorrect`,
    },
    loginGeneric: {
      id: `${scope}.errors.login.generic`,
    },
    findEnterprise: {
      id: `${scope}.errors.findEnterprise`,
    },
    fetchUserData: {
      id: `${scope}.errors.fetchUserData`,
    },
    invalidURL: {
      id: `${scope}.errors.invalidURL`,
    },
  },
};
